export default __webpack_public_path__ + "static/media/acceso-denegado.24448e3c.png";